import { render, staticRenderFns } from "./CategoryTree.vue?vue&type=template&id=31ade360"
import script from "./CategoryTree.vue?vue&type=script&lang=js"
export * from "./CategoryTree.vue?vue&type=script&lang=js"
import style0 from "./CategoryTree.vue?vue&type=style&index=0&id=31ade360&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports